import React, { useCallback, useState, useMemo, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useSelector, useDispatch } from 'react-redux'

import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'

import Table from 'components/table/SimpleTable'
import Confirm from 'components/dialog/Confirm'
import Link from 'components/widgets/Link'

import userSelectors from '../store/selectors/user'
import projectSelectors from '../store/selectors/project'
import projectActions from '../store/modules/project'
import routerActions from '../store/modules/router'

import icons from 'icons'
import fileUtils from 'utils/file'

const AddIcon = icons.add
const EditIcon = icons.edit
const DeleteIcon = icons.delete
const ImportExportIcon = icons.importExport

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(5),
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    '& .title': {
      flexGrow: 1,
      textAlign: 'left',
    },
    '& .actions': {
      flexGrow: 1,
      textAlign: 'right',
    }
  },

}))

const FIELDS = [{
  name: 'link',
  title: 'Name',
}]

const Home = ({

}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const projects = useSelector(projectSelectors.data)
  const user = useSelector(userSelectors.data)
  const [deletingProject, setDeletingProject] = useState(null)

  const onAddProject = useCallback(() => {
    dispatch(projectActions.addProject())
  })

  const onImportProject = useCallback(async () => {
    const data = await fileUtils.importFile()
    dispatch(projectActions.importProject({data}))
  })

  const onEditProject = useCallback((id) => {
    dispatch(routerActions.navigateTo('project', {
      id,
    }))
  })

  const onCloseDeleteWindow = useCallback(() => {
    setDeletingProject(null)
  })

  const onDeleteProject = useCallback(() => {
    dispatch(projectActions.deleteProject(deletingProject))
    setDeletingProject(null)
  }, [
    deletingProject,
  ])

  const getActions = useCallback((item) => {
    return (
      <>
        {
          item.owner == user.id && (
            <>
              <Button
                size="small"
                variant="contained"
                onClick={ () => setDeletingProject(item) }
              >
                Delete&nbsp;<DeleteIcon />
              </Button>
              &nbsp;&nbsp;&nbsp;
            </>
          )
        }
        <Button
          size="small"
          color="primary"
          variant="contained"
          onClick={ () => onEditProject(item.id) }
        >
          Edit&nbsp;<EditIcon />
        </Button>
      </>
    )
  }, [
    user,
  ])

  const tableData = useMemo(() => {
    return projects.map(project => {
      return Object.assign({}, project, {
        link: (
          <Link
            name="project"
            params={{
              id: project.id,
            }}
          >
            { project.name }
          </Link>
        )
      })
    })
  }, [
    projects,
  ])

  useEffect(() => {
    dispatch(projectActions.loadProjects())
  }, [])

  return (
    <div className={ classes.root }>
      <div className={ classes.header }>
        <div className="title">
          <Typography variant="h6">
            Your Projects
          </Typography>
        </div>
        <div className="actions">
          <Button
            size="small"
            variant="contained"
            onClick={ onImportProject }
          >
            Import&nbsp;<ImportExportIcon />
          </Button>
          &nbsp;&nbsp;&nbsp;
          <Button
            size="small"
            color="primary"
            variant="contained"
            onClick={ onAddProject }
          >
            New Project&nbsp;<AddIcon />
          </Button>
        </div>
      </div>
      
      <Table
        data={ tableData }
        fields={ FIELDS }
        getActions={ getActions }
      />
      {
        deletingProject && (
          <Confirm
            title={`Delete ${deletingProject.name}?`}
            onClose={ onCloseDeleteWindow }
            onSubmit={ onDeleteProject }
          >
            <Typography>
              Are you absolutely sure you want to delete {deletingProject.name}?
            </Typography>
          </Confirm>
        )
      }
    </div>
  )
}

export default Home